<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
.btn{
  text-transform: none; /* 勝手に大文字になる機能を全体的に無効化 */
}

a {
  text-decoration: none;
}

ul {
  list-style-type: none
}

h1 {
  font-size: 20px;
}

h2 {
  font-size: 14px;
}
h3 {
  font-size: 14px;
  color: #AAA;
}
body p {
  font-size: 14px;
}

.card {
  box-shadow: 0 1px 1px 1px rgba(0,0,0,.1);
}



</style>



// WEBPACK FOOTER //
// App.vue?cc96f354